import React from "react";

const PublishIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="47"
      height="40.816"
      viewBox="0 0 47 40.816"
    >
      <g
        id="Group_1154"
        data-name="Group 1154"
        transform="translate(-2.5 -8.7)"
      >
        <path
          id="Path_1242"
          data-name="Path 1242"
          d="M49.473,48.587l-5.838-7.569a1.72,1.72,0,0,0-2.721,0l-5.887,7.569a1.721,1.721,0,0,0,1.385,2.771H39.38v13.16a.992.992,0,0,0,.989.989h3.76a.992.992,0,0,0,.989-.989V51.358h2.968A1.721,1.721,0,0,0,49.473,48.587Z"
          transform="translate(-16.25 -15.992)"
          fill={fill ? fill : "#fb9f34"}
        />
        <path
          id="Path_1243"
          data-name="Path 1243"
          d="M46.136,8.7H5.864A3.368,3.368,0,0,0,2.5,12.064V42.293a3.41,3.41,0,0,0,3.364,3.414H18.183a.761.761,0,0,0,.742-.742v-2.82a.761.761,0,0,0-.742-.742H7a.234.234,0,0,1-.247-.247V18.694H45.245V41.2a.265.265,0,0,1-.247.247H33.817a.761.761,0,0,0-.742.742v2.82a.761.761,0,0,0,.742.742H46.136A3.368,3.368,0,0,0,49.5,42.392V12.114A3.379,3.379,0,0,0,46.136,8.7Zm-38,6.432A1.435,1.435,0,1,1,9.575,13.7,1.436,1.436,0,0,1,8.14,15.132Zm4.4,0A1.479,1.479,0,0,1,11.059,13.7a1.46,1.46,0,0,1,2.919,0A1.405,1.405,0,0,1,12.543,15.132Zm4.453,0a1.435,1.435,0,1,1,0-2.869A1.479,1.479,0,0,1,18.48,13.7,1.513,1.513,0,0,1,17,15.132Z"
          fill={fill ? fill : "#fb9f34"}
        />
      </g>
    </svg>
  );
};

export default PublishIcon;
